import device from '@tencent/device';
import { loadScript } from './util';
import { useAuth } from '@/store/auth';

/**
 * 加载微信
 */
export const beacon = (calls?: string, ...args: any[]) => (window.Midas
  ? Promise.resolve()
  : loadScript({
    url: '//beacon.cdn.qq.com/sdk/4.5.9/beacon_web.min.js',
    retry: true,
  })
).then(() => {
  if (calls) {
    const p = calls.split(/\./);
    const method = p[p.length - 1];
    let obj = window.BeaconAction;

    if (!window.BeaconAction) {
      console.log('wx 加载失败');
      Promise.reject();
    }

    p.slice(0, -1).forEach((name) => {
      obj = obj[name];
    });
    obj[method].apply(obj, args);
  }
  return window.BeaconAction;
});


const REPORT_EVENT = 'payment_pc_page'; // datahub数据链路上定义的event

/**
 * 灯塔上报，获取全局单例beacon上报对象
 * 进入页面时可利用setParams进行页面级内容设置：
 * getBeacon().setParams({params})
 * 使用：
 * getBeacon().report({needReportParams});
 */
export const getBeacon = (): QBVipBeacon => {
  if (beaconVisitor) {
    return beaconVisitor;
  }
  beaconVisitor = new QBVipBeacon();
  return beaconVisitor;
};

let beaconVisitor: QBVipBeacon;

/**
 * 获取基础上报字段，结构参考BeaconReportParamBase
 *
 * @return {BeaconReportParamBase}
 */
const createBaseInfo = (): BeaconReportParamBase => {
  const {
    deviceInfo,
  } = useAuth.storeInfo();
  const qbVersion = device.QQBrowserVersion as string;
  const timestamp = new Date().getTime();
  const tempArray = /MO=\s*(.+?)\s*(&|$)/.exec(deviceInfo?.qua2 || deviceInfo?.qua || '');
  const deviceType = tempArray?.[1] || 'null';
  const platId = device.isIOS ? 2 : 1;
  const idfa = deviceInfo?.idfa || '';
  return {
    ...deviceInfo,
    timestamp,
    platId,
    qbVersion,
    deviceType,
    business: 1, // 浏览器为1
    idfa,
  };
};

export default class QBVipBeacon {
  private beacon: any;

  // appkey: device.isAndroid ? '0M300HCVM70A7LSZ' : '0M3009N30Q074ILH',
  // appkey: isAndroid() ? 'LOGDEBUGKEY00001' : 'LOGDEBUGKEY00001',
  // isDebug: true,

  /**
   * 注：在进行实时联调时需要将key换为实时联调用的appkey：LOGDEBUGKEY00001
   * 0M300HCVM70A7LSZ
   */
  constructor() {
    !this.beacon && beacon().then((BeaconAction: any) => {
      this.init(BeaconAction);
    });
  }

  init(BeaconAction: any) {
    this.beacon = new BeaconAction({
      appkey: device.isAndroid ? '0M300HCVM70A7LSZ' : '0M3009N30Q074ILH', // 系统或项目id, 必填
      isDebug: false,
    });
  }

  /**
   * 设置部分参数，一般在页面级进行设置
   */
  public setParams(params: Partial<BeaconReportParamFull> = {}) {
    Object.assign(DEFAULT_REPORT_PARAMS, DEFAULT_REPORT_PARAMS, params);
  }

  /**
   * 上报，传入上报需要的params，默认填写链接中携带的adtag，可覆盖
   */
  public async report(params: Partial<BeaconReportParamFull> = {}, REPORT_BUS_EVENT?: any) {
    const baseParams = createBaseInfo();
    const data = JSON.parse(JSON.stringify(DEFAULT_REPORT_PARAMS));
    Object.assign(data, data, params, baseParams);
    const reportKey = REPORT_BUS_EVENT ? REPORT_BUS_EVENT : REPORT_EVENT;
    // eslint-disable-next-line max-len
    console.log('QBVipBeacon report data', 'pageModule', data.page_module, 'actType', data.act_type, 'actModule', data.act_module, 'aid', data.aid, 'status', data.status, 'pay_status', data.pay_status, data, 'reportKey', reportKey);
    const beaconInstance = await beacon();
    this.init(beaconInstance);
    this.beacon.onDirectUserAction(reportKey, {
      event_value: JSON.stringify(data),
    });
    return true;
  }
}

export interface BeaconReportParamBase {
  guid?: string;
  idfv?: string;
  ip?: string;
  isKingCardUser?: string;
  networkType?: string;
  perfclass?: string;
  qadid?: string;
  qimei?: string;
  qimei36?: string;
  qua2?: string;
  systemMode?: string;
  systemVersion?: string;
  ua?: string;
  timestamp?: number;
  platId?: number;
  qbVersion?: string;
  deviceType?: string;
  business?: number;
  idfa?: string;
}

export interface BeaconReportParamFull extends BeaconReportParamBase {
  extinfo1: string, // 扩展字段
  extinfo2: string, // 扩展字段
  extinfo3: string, // 扩展字段
  extinfo4: string, // 扩展字段
  extinfo5: string, // 扩展字段
}

const DEFAULT_REPORT_PARAMS: BeaconReportParamFull = {
  extinfo1: '',
  extinfo2: '',
  extinfo3: '',
  extinfo4: '',
  extinfo5: '',
};
